// import { Post } from '@/services/Api'
import { ListRoleURL, UpdateRoleURL, CreateRoleURL } from '@/consts/consts'
import {POST} from "@/utils/request/request";

export function ListRole(data) {
  return POST(ListRoleURL, data)
}

export function UpdateRole(data) {
  return POST(UpdateRoleURL, data)
}

export function CreateRole(data) {
  return POST(CreateRoleURL, data)
}
